import videojs from 'video.js'
import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
import store from '../store'

// videojs.Hls.xhr.beforeRequest = function(options) {
//   if (options.headers == undefined) {
//      options.headers = {}
//   }
//   options.headers["Authorization"] = store.state.user.token
//   return options
// }

export default videojs